import ProfileImage from '../assets/profile.webp'

export const instructorsDetails = [
  {
    id: 1,
    name: 'Kshitiz Miglani',
    designation: 'Co-Founder Devsnest',
    type: 'DSA Instructor',
    previous_designation: 'Ex Amazon, PayTM',
    profile_image_url: ProfileImage.src,
    description:
      'Kshitiz has worked as a developer in Amazon, PayTM, and Samsung, leading critical projects and creating scalable solutions.'
  },
  {
    id: 2,
    name: 'Gaurav Sen',
    designation: '',
    type: 'Frontend Instructor',
    previous_designation: 'Mentor with exp of 10 years',
    profile_image_url: ProfileImage.src,
    description:
      'Gaurav is a Software Engineer by profession with 10 years of industry experience. But in 2020, he started tutoring as a hobby now helping thousands of students.'
  }
  // {
  //   id: 3,
  //   name: 'Kshitiz Miglani',
  //   designation: 'Co-Founder Devsnest',
  //   type: 'DSA Instructor',
  //   previous_designation: 'Ex Amazon',
  //   profile_image_url: ProfileImage.src,
  //   description:
  //     'Lorem ipsum dolor sit amet consectetur. Adipiscing suspendisse turpis arcu sodales pulvinar justo leo. Euismod sit id porta lorem viverra duis euismod. Amet eu est dictum pellentesque orci sit.'
  // }
]
